module.exports = __webpack_public_path__ + "media/Island.90ef25b5.mp4";